var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Payment-Pending_Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RMC/CEM-Statuses-for-orders-and-deliveries",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Order-Status-RMC-delivered-Labels-Icons-Tooltips",
    transform: "translate(-4161.000000, -697.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-Pending_Icon",
    transform: "translate(4161.000000, 697.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#8BA5AE",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Payment-Pending-Motive",
    transform: "translate(20.000000, 22.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,14 L38,19 L5,19 L5,39 L41,39 L41,30 L46,30 L46,39 C46,41.6776316 43.8194598,43.8812327 41.1097242,43.9953574 L40.8888889,44 L5.11111111,44 C2.37397661,44 0.121406587,41.8668629 0.00474579223,39.2160346 L0,39 L0,19 C0,16.3223684 2.18054017,14.1187673 4.89027575,14.0046426 L5.11111111,14 L38,14 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,21 C18.35,21 15,24.35 15,28.5 C15,32.65 18.35,36 22.5,36 C26.65,36 30,32.65 30,28.5 C30,24.35 26.65,21 22.5,21 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,30 L56,48.9230769 C56,51.7153846 53.7263158,54 50.9473684,54 L8,54 L8,48.9230769 L8,48.9230769 L50.9473684,48.9230769 L50.947,30 L56,30 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,0 L57,7.2 L56.9883333,7.2 L57,7.212 L52.3333333,12 L57,16.8 L56.9883333,16.812 L57,16.812 L57,24 L43,24 L43,16.812 L43.0116667,16.812 L43,16.8 L47.6666667,12 L43,7.212 L43.0116667,7.2 L43,7.2 L43,0 L57,0 Z M50,15 L47,17.7280847 L47,21 L53,21 L53,17.7280847 L50,15 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingPayment);
export default __webpack_public_path__ + "static/media/pendingPayment.5bb6b63c19e998d986b18403b0a2a4c7.svg";
export { ForwardRef as ReactComponent };